/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgOrganizationsDesignRetrievePathOrgId, OrgOrganizationsDesignRetrieveStatus200 } from "../types/OrgOrganizationsDesignRetrieve.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgOrganizationsDesignRetrieve } from "../requests/orgOrganizationsDesignRetrieve.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgOrganizationsDesignRetrieveQueryKey = (org_id?: MaybeRefOrGetter<OrgOrganizationsDesignRetrievePathOrgId>) =>
	[{ url: "/api/org/organizations/:org_id/design/", params: { org_id: org_id } }] as const;

export type OrgOrganizationsDesignRetrieveQueryKey = ReturnType<typeof orgOrganizationsDesignRetrieveQueryKey>;

export function orgOrganizationsDesignRetrieveQueryOptions(
	org_id?: MaybeRefOrGetter<OrgOrganizationsDesignRetrievePathOrgId>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgOrganizationsDesignRetrieveQueryKey(org_id);
	return queryOptions<OrgOrganizationsDesignRetrieveStatus200, ResponseErrorConfig<Error>, OrgOrganizationsDesignRetrieveStatus200>({
		enabled: () => !!toValue(org_id),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgOrganizationsDesignRetrieve(toValue(org_id!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * {@link /api/org/organizations/:org_id/design/}
 */
export function useOrgOrganizationsDesignRetrieve<
	TData = OrgOrganizationsDesignRetrieveStatus200,
	TQueryData = OrgOrganizationsDesignRetrieveStatus200,
	TQueryKey extends QueryKey = OrgOrganizationsDesignRetrieveQueryKey,
>(
	org_id?: MaybeRefOrGetter<OrgOrganizationsDesignRetrievePathOrgId>,
	options: {
		query?: Partial<UseQueryOptions<OrgOrganizationsDesignRetrieveStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
			client?: QueryClient;
		};
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey =
		(resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? orgOrganizationsDesignRetrieveQueryKey(org_id);

	const query = useQuery(
		{
			...orgOrganizationsDesignRetrieveQueryOptions(org_id, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<
			OrgOrganizationsDesignRetrieveStatus200,
			ResponseErrorConfig<Error>,
			TData,
			OrgOrganizationsDesignRetrieveStatus200,
			TQueryKey
		>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
